import React from "react";
import styles from "./Mixing.module.css";
import CheckListComponent from "../../../../../components/CheckListComponent/CheckListComponent";
const Mixing = () => {
  const Options = [
    { title: "Mixer sanitized prior to use  " },
    { title: "Ingredient scale calibrated" },
    { title: "Water measurement double-checked" },
    { title: "Verify ingredient temperature before mixing (if applicable)" },
    { title: "Record lot numbers for traceability (if required)" },
    { title: "No food or drink in the areas" },
  ];

  const Options2 = [
    { title: "Confirm all ingredients are within expiry date" },
    { title: "Verify ingredient temperature before mixing (if applicable)" },
    { title: "Record lot numbers for traceability (if required)" },
    { title: "Confirm mixing bowl and attachments are sanitized" },
    { title: "Mixing speed and time match recipe instructions" },
  ];

  return (
    <div className={styles.MainCont}>
      <div className={styles.RightCont}>
        <CheckListComponent Options={Options} Heading={"GMP"} />
      </div>
    </div>
  );
};

export default Mixing;
